var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.JwtRepo.is_logged_in)?_c('em',[_vm._v(" Your session is expired. Please "),_c('b-link',{on:{"click":_vm.login}},[_vm._v("Sign In")]),_vm._v(". ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }